import { BiogenTherapeuticArea } from 'basics/enums/biogen.enums';
import { SelectOption } from 'basics/options/options.types';

const useTherapeuticAreaOptions = (): SelectOption[] => {
  return Object.values(BiogenTherapeuticArea).map((ta) => ({ id: ta, label: ta }));
};

export default useTherapeuticAreaOptions;
